// -----------------------------
// GLOBAL VIJAY COUNTDOWN TIMER
// -----------------------------

// Función para convertir "YYYY-MM-DD HH:MM:SS" en un objeto Date local
function parseCountdownDate(dateString) {
  if (!dateString) return null;

  const parts = dateString.trim().split(" ");
  const datePart = parts[0];
  const timePart = parts[1] || "00:00:00";

  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute, second] = timePart.split(":").map(Number);

  return new Date(year, month - 1, day, hour, minute, second);
}

// Obtenemos la fecha final desde el tema
const endDateObj = parseCountdownDate(
  window.themeCountdownEndDate || "2030-01-01 00:00:00"
);
const endDate = endDateObj.getTime();

// Actualizar el countdown cada segundo
function updateCountdown() {
  const now = new Date().getTime();
  const distance = endDate - now;

  if (distance < 0) {
    // Expired → esconder contadores
    const bar = document.getElementById("countdown-timer");
    if (bar) bar.textContent = "00h 00m 00s";

    const productTimers = document.querySelectorAll(".product-countdown-timer");
    productTimers.forEach((el) => (el.textContent = "00h 00m 00s"));

    return;
  }

  // Cálculo REAL con días incluidas
  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Formato final
  let formatted = "";

  if (days > 0) {
    formatted += days + "d ";
  }

  formatted +=
    ("0" + hours).slice(-2) +
    "h " +
    ("0" + minutes).slice(-2) +
    "m " +
    ("0" + seconds).slice(-2) +
    "s";

  // Bar
  const bar = document.getElementById("countdown-timer");
  if (bar) bar.textContent = formatted;

  // Product timers
  const productTimers = document.querySelectorAll(".product-countdown-timer");
  productTimers.forEach((el) => (el.textContent = formatted));
}

setInterval(updateCountdown, 1000);
updateCountdown();
